// extracted by mini-css-extract-plugin
export default {"root":"EditFlagForm_root__7JvI8","form":"EditFlagForm_form__VkU13","after":"EditFlagForm_after__st3A-"};